import { render, staticRenderFns } from "./BackendTable-Sortable.vue?vue&type=template&id=5922ed83"
import script from "./BackendTable-Sortable.vue?vue&type=script&lang=js"
export * from "./BackendTable-Sortable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports